<div class="flex-column flex-fill">
  <app-header [title]="'Default Frac Fleet Teams'" class="flex-item-auto" [loading]="loading">
    <button type="button" kendoButton class="corneredbutton" [disabled]="editedFracFleets.size <= 0" themeColor="primary" class="me-1" (click)="saveChanges()">Save</button>
    @if (editedFracFleets.size > 0) {
    <button type="button" kendoButton themeColor="primary" class="me-1" (click)="cancelEdit()">Cancel</button>
    }
  </app-header>
  <ag-grid-angular #agGridFF style="height: 100%;" class="ag-theme-balham" (gridReady)="onGridReady($event)"
    [gridOptions]="projectTeamFracFleetsGridOptions" (cellValueChanged)="onCellValueChanged($event)" (rowEditingStopped)="onRowEditStopped($event)">
  </ag-grid-angular>
</div>